import { useEffect, useMemo, useState } from "react";

const getStableProductCardKey = (item, index) => {
  const stableValue =
    item?.id ?? item?.real_slug ?? item?.slug ?? item?.product_url ?? item?.url;

  return stableValue !== null && stableValue !== undefined && stableValue !== ""
    ? String(stableValue)
    : `product-${index}`;
};

const StableMasonryGrid = ({
  items = [],
  renderItem,
  className = "",
  keyPrefix = "masonry-product",
  mobileColumns = 2,
  tabletColumns = 3,
  desktopColumns = 5,
  wideColumns = desktopColumns,
}) => {
  const resolveColumnCount = () => {
    if (typeof window === "undefined") {
      return mobileColumns;
    }

    const width = window.innerWidth;

    if (width >= 1536) {
      return wideColumns;
    }

    if (width >= 1280) {
      return desktopColumns;
    }

    if (width >= 768) {
      return tabletColumns;
    }

    return mobileColumns;
  };

  const [columnCount, setColumnCount] = useState(resolveColumnCount);

  useEffect(() => {
    const handleResize = () => {
      setColumnCount(resolveColumnCount());
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileColumns, tabletColumns, desktopColumns, wideColumns]);

  const columns = useMemo(() => {
    const nextColumns = Array.from(
      { length: Math.max(1, columnCount) },
      () => [],
    );

    items.forEach((item, index) => {
      const columnIndex = index % nextColumns.length;

      nextColumns[columnIndex].push({
        item,
        originalIndex: index,
      });
    });

    return nextColumns;
  }, [items, columnCount]);

  return (
    <div className={className}>
      <div className="flex items-start gap-x-3">
        {columns.map((column, columnIndex) => (
          <div
            key={`${keyPrefix}-column-${columnIndex}`}
            className="flex min-w-0 flex-1 flex-col gap-y-0"
          >
            {column.map(({ item, originalIndex }) => (
              <div
                key={`${keyPrefix}-${getStableProductCardKey(
                  item,
                  originalIndex,
                )}`}
                className="min-w-0"
              >
                {renderItem(item, originalIndex)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StableMasonryGrid;
